import { combineReducers } from "redux";
import app from "./slices/appSlice";
import flow from "./slices/flowSlice";

const rootReducer = combineReducers({
	app,
	flow
});

export default rootReducer;
